import React, { createContext, useContext, useEffect, useState } from 'react';
import isEmpty from 'lodash/isEmpty';
import { createSearchVariablesFromContextData } from './searchContextUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const SearchContext = /*#__PURE__*/createContext({});
const SearchProvider = _ref => {
  let {
    children,
    searchData
  } = _ref;
  const [currentSearchData, setCurrentSearchData] = useState(searchData);
  const [isSearchComplete, setIsSearchComplete] = useState(false);
  const [isSearchFormOpen, setIsSearchFormOpen] = useState(false);
  const searchVariables = createSearchVariablesFromContextData(currentSearchData);
  useEffect(() => {
    sessionStorage.setItem('currentSearchData', JSON.stringify(currentSearchData));
  }, [currentSearchData]);
  const setSearchData = value => {
    setCurrentSearchData(state => ({
      ...state,
      ...value
    }));
  };
  return /*#__PURE__*/_jsx(SearchContext.Provider, {
    value: {
      currentSearchData,
      isSearchComplete,
      searchVariables,
      setIsSearchComplete,
      setSearchData,
      isSearchFormOpen,
      setIsSearchFormOpen
    },
    children: children
  });
};
const useSearch = () => {
  const searchContext = useContext(SearchContext);
  if (isEmpty(searchContext)) {
    throw new Error('useSearch must be used within a SearchContextProvider');
  }
  return {
    ...searchContext
  };
};
export { SearchProvider, useSearch };
//# sourceMappingURL=SearchContext.js.map